import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import HoneybadgerVue from '@honeybadger-io/vue'

Vue.config.productionTip = true

export const currentUser = store.state.user != null

import baseComponents from '@listen360/alexandria'
baseComponents.forEach(component => {
  Vue.component(component.name, component)
})

const honeybadgerConfig = {
  apiKey: '9b860788',
  environment: process.env.NODE_ENV
}

Vue.use(HoneybadgerVue, honeybadgerConfig)

Vue.config.errorHandler = function(err, vm, info) {
  HoneybadgerVue.notify({
    error: err,
    params: { info: info }
  })
}

import '@listen360/alexandria/dist/listen360-alexandria.css'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
